// Module
var code = `<a
  class="breadcrumb-link"
  data-channel="ROUTE"
  data-event-prevent-default="true"
  data-page-id="{{pageId}}"
  data-text="{{title}}"
  data-end-route="true"
  href="{{href}}"
  >{{title}}</a
>
`;
// Exports
module.exports = code;